import { GoogleAnalyticsState } from '../../features/config';

export const getGoogleAnalyticsMeasurementId = (googleAnalytics: GoogleAnalyticsState): string => {
  const origin = window.location.origin;
  const domainMeasurementIds = googleAnalytics.domainMeasurementIds;
  const domain = Object.keys(domainMeasurementIds).find((domain) => origin.indexOf(domain) >= 0);
  return domain ? domainMeasurementIds[domain]! : googleAnalytics.measurementId;
};
